import {
  Autocomplete,
  Box,
  Button,
  Container,
  Grid,
  Stack,
  Typography,
  Modal,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Rating,
  Fab,
  Slide,
  Checkbox,
} from "@mui/material";
import { Audio } from "react-loading-icons";
import GlobalHeader from "../../../components/GlobalHeader";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useApi from "../../../hooks/useApi";
import SnackAlert from "../../../components/SnackAlert";
import useSnack from "../../../hooks/useSnack";
import { LoadingButton } from "@mui/lab";
import { useUser } from "../../../hooks/useUser";
import {
  FaSpotify,
  FaTiktok,
  FaInstagram,
  FaYoutube,
  FaFacebook,
  FaTwitter,
} from "react-icons/fa";
import CardsProductores, {
  formatGeneros,
} from "../../../components/cardsProductores";
import NavigationIcon from "@mui/icons-material/Navigation";
import countries from "../../../utils/countries";
import { hrefSeguro } from "../../../utils/hrefSeguro";
import { opcionesDeEnvio, ENVIO_SOCIAL } from "../../../utils/plan";
import Insignia5RC from "../../../components/Insignia5RC";

//style modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: { xs: 300, sm: "400" },
  maxHeight: 500,
  overflow: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "20px",
  "::-webkit-scrollbar": {
    display: "none",
  },
};


const colors = {
  spotify: "#81b71a",
  youtube: " #c4302b",
};

const socialNetwork = [
  { name: "facebook", Icon: FaFacebook },
  { name: "instagram", Icon: FaInstagram },
  { name: "youtube", Icon: FaYoutube },
  { name: "spotify", Icon: FaSpotify },
  { name: "tiktok", Icon: FaTiktok },
  { name: "twitter", Icon: FaTwitter },
];

export default function VistaAInfluencer() {
  const [mainData, setMainData] = useState([]);
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const { user, updateUser } = useUser();
  const { loadApi, loadedApi, loadingApi } = useApi();
  // La misma pantalla envía canciones y eventos: cambia solo cuál de los dos
  // ids viene en la URL (/artista/enviar/:songId o /artista/enviar-evento/:eventoId).
  const { songId, eventoId } = useParams();
  const esEvento = !!eventoId;
  const [favorites, setFavorites] = useState([]);
  const [open, setOpen] = useState(false);
  // Envío de uno en uno («Enviar» de una tarjeta): va aparte de la selección
  // múltiple, así no queda marcado en el recuadro después de enviarlo.
  const [individual, setIndividual] = useState(null); // id del difusor
  // Tipo de envío elegido en el modal: { amount, radarCoin }.
  const [plan, setPlan] = useState(null);
  const handleClose = () => {
    setOpen(false);
    setIndividual(null);
  };
  const [search, setSearch] = useState("");
  const [generoFilter, setGeneroFilter] = useState(null);
  const [paisFilter, setPaisFilter] = useState(null);
  const [info, setInfo] = useState(null);
  const [value, setValue] = useState(2);
  //Seleccionar uno o mas productores (recuadro de cada tarjeta)
  const [producers, setProducers] = useState([]);

  useEffect(() => {
    getProductores();
    loadFavorites();
  }, [user]);

  //Mostrar productores
  const getProductores = () => {
    loadApi("artista/productores", true, "get")
      .then((response) => {
        setMainData(response.data || []);
      })
      .catch((e) => {
        showSnack(e.message, "error", false);
      });
  };

  //Enviar cancion o evento: al difusor de «Enviar» o a los seleccionados
  const sendSong = async () => {
    if (destinatarios.length === 0) {
      showSnack("Selecciona al menos un difusor", "error");
      return;
    }
    if (!plan) {
      showSnack("Elige el tipo de envío", "error");
      return;
    }

    // Quien no tiene los 5 RC activos recibe un Envío Social.
    const envios = destinatarios.map((productorId) => {
      const suyo =
        plan.radarCoin > ENVIO_SOCIAL.radarCoin &&
        !difusorDe(productorId).acepta5RC
          ? ENVIO_SOCIAL
          : plan;
      return {
        productorId,
        ...(esEvento ? { eventoId } : { songId }),
        amount: suyo.amount,
        radarCoin: suyo.radarCoin,
      };
    });

    try {
      const { message } = await loadApi("artista/envios", true, "post", {
        producers: envios,
      }).then((data) => data.data);
      showSnack(message);
      updateUser();
      // Lo que ya se mandó deja de estar seleccionado.
      if (!individual) setProducers([]);
      handleClose();
    } catch (error) {
      showSnack(error.message, "error");
    }
  };


  //OBTENER FAVORITOS
  const loadFavorites = () => {
    loadApi("artista/favoritos", true, "get").then((res) => {
      setFavorites(res.data);
    });
  };

  //AGREGAR FAVORITOS
  const updateFavorite = (id) => {
    let favoritos;
    if (user.profile.favorites) {
      favoritos = user.profile.favorites;
      if (favoritos.includes(id))
        favoritos = favoritos.filter((item) => item !== id);
      else favoritos.push(id);
    } else favoritos = [id];
    if(favoritos.length === 0)
      favoritos = null;
    loadApi("artista/favoritos", true, "put", { favorites: favoritos }).then(
      (res) => {
        showSnack(res.data.message);
        updateUser();
      }
    );
  };

  //ABRIR MODAL: con `productor`, su información («Ver más»); sin él, el
  //envío a ese difusor solo («Enviar»), que no toca la selección múltiple.
  const handleOpen = (productorId, productor) => {
    setPlan(null);
    if (productor) {
      setInfo(productor);
      setIndividual(null);
    } else {
      setInfo(null);
      setIndividual(productorId);
    }
    setOpen(true);
  };

  // El modal de envío para los seleccionados (botón flotante).
  const openSendModal = () => {
    setInfo(null);
    setIndividual(null);
    setPlan(null);
    setOpen(true);
  };

  //ELEGIR PLAN
  const handleOpciones = (amount, radarCoin) => setPlan({ amount, radarCoin });

  //Normalizar generos_musicales a array (puede venir como array, string JSON o string plano)
  const normalizeGeneros = (g) => {
    if (Array.isArray(g)) return g;
    if (typeof g === "string") {
      try {
        const parsed = JSON.parse(g);
        return Array.isArray(parsed) ? parsed : [String(parsed)];
      } catch {
        return g ? [g] : [];
      }
    }
    return [];
  };

  //Opciones del filtro: géneros presentes entre los difusores cargados
  const generosDisponibles = [
    ...new Set(
      mainData.flatMap((person) =>
        normalizeGeneros(person.profile?.generos_musicales)
      )
    ),
  ].sort((a, b) => a.localeCompare(b));

  //Opciones del filtro: países presentes entre los difusores cargados
  const paisesDisponibles = [
    ...new Set(mainData.map((person) => person.profile?.pais).filter(Boolean)),
  ]
    .map((code) => ({ value: code, label: countries[code] || code }))
    .sort((a, b) => a.label.localeCompare(b.label));

  //Listado visible: búsqueda por nombre + filtros por género y país, sin mutar mainData
  const visibleData = mainData.filter((person) => {
    const matchesSearch =
      !search ||
      person.profile?.nombre_media
        ?.toLowerCase()
        .includes(search.toLowerCase());
    const matchesGenero =
      !generoFilter ||
      normalizeGeneros(person.profile?.generos_musicales).includes(
        generoFilter
      );
    const matchesPais = !paisFilter || person.profile?.pais === paisFilter.value;
    return matchesSearch && matchesGenero && matchesPais;
  });

  // Los datos de un difusor seleccionado, venga del listado o de favoritos.
  const difusorDe = (id) => {
    const delListado = mainData.find((d) => d.id === id);
    if (delListado)
      return {
        nombre: delListado.profile?.nombre_media,
        tipo: delListado.profile?.tipo,
        acepta5RC: Boolean(delListado.acepta5RC),
      };
    const favorito = favorites.find((f) => f.userId === id);
    return {
      nombre: favorito?.nombre_media,
      tipo: favorito?.tipo,
      acepta5RC: Boolean(favorito?.acepta5RC),
    };
  };

  // Tipos de envío del modal. El de 5 RC solo va a los difusores que el
  // equipo verificó para eso (insignia «5 RC verificado»); al resto, aunque se
  // elija esa opción, se les manda Envío Social. Su texto cambia según a
  // quién va (nota editorial para un medio, mención para un creador o una
  // radio o TV).
  // A quién va el envío: el de «Enviar», o los seleccionados en el recuadro.
  const destinatarios =
    individual != null ? [individual] : producers.map((p) => p.productorId);
  const seleccionados = destinatarios.map((id) => ({
    id,
    ...difusorDe(id),
  }));
  const aceptan5RC = seleccionados.filter((d) => d.acepta5RC);
  const soloSocial = seleccionados.filter((d) => !d.acepta5RC);
  const opciones =
    aceptan5RC.length > 0
      ? opcionesDeEnvio(aceptan5RC.map((d) => d.tipo))
      : [ENVIO_SOCIAL];
  const totalDe = (radarCoin) =>
    radarCoin > 1
      ? aceptan5RC.length * radarCoin + soloSocial.length * ENVIO_SOCIAL.radarCoin
      : seleccionados.length * radarCoin;

  //Seleccionar productores

  const handleSelectProducers = ({ checked }, { id }) => {
    if (checked) {
      setProducers((props) => [
        ...props,
        { productorId: id, ...(esEvento ? { eventoId } : { songId }) },
      ]);
    } else {
      const pre_producers = producers.filter((pro) => pro.productorId !== id);
      setProducers(pre_producers);
    }
  };

  return (
    <>
      <GlobalHeader />
      {!loadedApi.includes("get__artista/productores") &&
      mainData.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: `calc(100vh - ${
              window.document.getElementById("GlobalHeader")?.offsetHeight ||
              "64"
            }px - 32px)`,
          }}
        >
          <Audio fill="#F27224" />
        </Box>
      ) : (
        <Container>
          <Grid container>
            <Grid container item xs={12}>
              {/* TITULO */}
              <Grid item xs={12}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    variant="h4"
                    color="primary.main"
                    fontWeight="900"
                    fontSize={{ xs: "24px", sm: "34px" }}
                  >
                    FAVORITOS
                  </Typography>
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    <Autocomplete
                      options={paisesDisponibles}
                      value={paisFilter}
                      onChange={(e, value) => setPaisFilter(value)}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      noOptionsText="Sin países"
                      sx={{ minWidth: 180 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Filtrar por país"
                        />
                      )}
                    />
                    <Autocomplete
                      options={generosDisponibles}
                      value={generoFilter}
                      onChange={(e, value) => setGeneroFilter(value)}
                      noOptionsText="Sin géneros"
                      sx={{ minWidth: 180 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Filtrar por género"
                        />
                      )}
                    />
                    <TextField
                      variant="standard"
                      label="Buscar..."
                      type="text"
                      autoComplete="off"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    ></TextField>
                  </Stack>
                </Stack>
              </Grid>
              {/* CONTENEDOR DE FAVORITOS */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    my: 4,
                    display: "grid",
                    gridTemplateColumns:
                      "repeat( auto-fill, minmax(230px, 1fr) )",
                    justifyItems: "center",
                    alignItems: "start",
                    gap: 2,
                    pb: 2,
                  }}
                >
                  {favorites.length === 0 ? (
                    <Typography variant="h6" fontWeight="500">
                      No tienes favoritos
                    </Typography>
                  ) : (
                    favorites?.map((dataItem, i) => (
                      //card todos
                      <Stack
                        sx={{
                          width: "200px",
                          p: "15px",
                          gap: "10px",
                          borderRadius: "10px",
                          justifyContent: "space-between",
                          ":hover": {
                            boxShadow: "rgba(0, 0, 0, 0.25) 0px 5px 15px",
                          },
                        }}
                        key={i}
                      >
                        <Stack gap="10px">
                          {/* header */}
                          <Stack>
                            <img
                              src={dataItem?.profileimg || "/assets/AVATAR.jpg"}
                              width="100%"
                              style={{
                                borderRadius: "10px",
                                boxShadow: "rgba(0, 0, 0, 0.25) 0px 5px 15px",
                              }}
                            />
                          </Stack>
                          {/* body */}
                          <Stack>
                            <Stack direction="row">
                              <Typography
                                noWrap
                                sx={{
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  width: "170px",
                                }}
                              >
                                {dataItem.nombre_media}
                              </Typography>
                              <img
                                src={`https://flagcdn.com/${dataItem.pais}.svg`}
                                alt="País"
                                width="30"
                                height="20"
                              />
                            </Stack>
                            <Typography
                              variant="body1"
                              color="grayText"
                              fontWeight={400}
                            >
                              {dataItem.tipo}
                            </Typography>
                            {dataItem.acepta5RC && (
                              <Insignia5RC
                                tipo={dataItem.tipo}
                                sx={{ alignSelf: "flex-start" }}
                              />
                            )}
                            <Stack>
                              <Typography variant="p" fontWeight={400}>
                                {formatGeneros(dataItem?.generos_musicales)}
                              </Typography>
                            </Stack>
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              {/* Para mandar a varios favoritos a la vez */}
                              <Checkbox
                                checked={producers.some(
                                  (p) => p.productorId === dataItem.userId
                                )}
                                onChange={({ target }) =>
                                  handleSelectProducers(target, {
                                    id: dataItem.userId,
                                  })
                                }
                                inputProps={{
                                  "aria-label": `Seleccionar ${dataItem.nombre_media}`,
                                }}
                              />
                              <Typography
                                variant="body1"
                                sx={{
                                  fontWeight: "400",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  ":hover": { color: "#F27224" },
                                }}
                                onClick={() =>
                                  handleOpen(dataItem.userId, dataItem)
                                }
                              >
                                Ver mas
                              </Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                        {/* button: con varios seleccionados se envía desde el botón flotante */}
                        <Stack display={producers.length > 0 ? "none" : "inherit"}>
                          <Button onClick={() => handleOpen(dataItem.userId)}>
                            Enviar
                          </Button>
                        </Stack>
                      </Stack>
                    ))
                  )}
                </Box>
              </Grid>
              {/* CONTENEDOR DE ITEMS */}
              <Grid item xs={12}>
                <Typography variant="h4" color="primary.main" fontWeight="900">
                  DIFUSORES
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    my: 4,
                    display: "grid",
                    gridTemplateColumns:
                      "repeat( auto-fill, minmax(230px, 1fr) )",
                    justifyItems: "center",
                    alignItems: "start",
                    gap: 2,
                    pb: 2,
                  }}
                >
                  {visibleData.length === 0 ? (
                    <Typography variant="h6" fontWeight="500">
                      No hay difusores que coincidan con la búsqueda o los
                      filtros seleccionados
                    </Typography>
                  ) : (
                    visibleData.map((dataItem, i) => (
                      //card todos
                      <Box key={i} sx={{ cursor: "pointer" }}>
                        <CardsProductores
                          dataItem={dataItem}
                          handleOpen={handleOpen}
                          updateFavorite={updateFavorite}
                          loading={loadingApi.includes(
                            "put__artista/favoritos"
                          )}
                          handleSelectProducers={handleSelectProducers}
                          producers={producers}
                        />
                      </Box>
                    ))
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
      <Slide
        direction="up"
        in={producers.length > 0}
        mountOnEnter
        unmountOnExit
      >
        <Box sx={{ position: "fixed", bottom: 30, right: 30, zIndex: 1300 }}>
          <Fab
            variant="extended"
            color="primary"
            onClick={openSendModal}
            aria-label={`Enviar ${esEvento ? "evento" : "canción"} a los difusores seleccionados`}
          >
            <NavigationIcon sx={{ mr: 1 }} />
            Enviar ({producers.length})
          </Fab>
        </Box>
      </Slide>
      {/* Modal información */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {!info ? (
          <Box sx={style}>
            <Typography variant="h6" textAlign="center">
              Seleccione una opción
            </Typography>
            {seleccionados.length > 0 && (
              <Typography variant="body2" color="GrayText" textAlign="center" mb={1}>
                Para: {seleccionados.map((d) => d.nombre).filter(Boolean).join(", ")}
              </Typography>
            )}
            <FormControl>
              <RadioGroup name="radarCoins" value={plan ? plan.radarCoin : ""}>
                {opciones.map((item) => (
                  <Stack key={item.radarCoin} mb={1}>
                    <FormControlLabel
                      value={item.radarCoin}
                      control={<Radio />}
                      label={<Typography fontWeight={600}>{item.titulo}</Typography>}
                      onChange={() =>
                        handleOpciones(item.amount, item.radarCoin)
                      }
                    />
                    {item.detalle ? (
                      item.detalle.map((d) => (
                        <Typography
                          key={d.para}
                          variant="body1"
                          color="GrayText"
                          fontWeight="400"
                          mb={0.5}
                        >
                          <strong>{d.para}:</strong> {d.descripcion}
                        </Typography>
                      ))
                    ) : (
                      <Typography
                        variant="body1"
                        color="GrayText"
                        fontWeight="400"
                      >
                        {item.descripcion}
                      </Typography>
                    )}
                    {item.radarCoin > ENVIO_SOCIAL.radarCoin &&
                      soloSocial.length > 0 && (
                        <Typography
                          variant="body2"
                          sx={{
                            mt: 0.5,
                            p: 1,
                            borderRadius: 1,
                            bgcolor: "rgba(242, 114, 36, 0.08)",
                          }}
                        >
                          <strong>
                            Solo aceptan Envío Social (1 RC):
                          </strong>{" "}
                          {soloSocial.map((d) => d.nombre).join(", ")}.{" "}
                          {soloSocial.length > 1
                            ? "A ellos se les manda"
                            : "A este difusor se le manda"}{" "}
                          Envío Social.
                        </Typography>
                      )}
                    {seleccionados.length > 0 && (
                      <Typography variant="body2" fontWeight={700} mt={0.5}>
                        Total: {totalDe(item.radarCoin)} RC
                        {item.radarCoin > ENVIO_SOCIAL.radarCoin &&
                          soloSocial.length > 0 &&
                          ` (${aceptan5RC.length} × ${item.radarCoin} RC + ${soloSocial.length} × ${ENVIO_SOCIAL.radarCoin} RC)`}
                      </Typography>
                    )}
                  </Stack>
                ))}
                {aceptan5RC.length === 0 && seleccionados.length > 0 && (
                  <Typography variant="body2" color="GrayText" mb={1}>
                    {seleccionados.length > 1
                      ? "Ninguno de los difusores que elegiste tiene"
                      : "Este difusor no tiene"}{" "}
                    activado el envío de 5 RC: solo{" "}
                    {seleccionados.length > 1 ? "aceptan" : "acepta"} Envío
                    Social.
                  </Typography>
                )}
              </RadioGroup>
              <LoadingButton
                loading={loadingApi.includes("post__artista/envios")}
                sx={{ px: 4, mt: 2 }}
                onClick={() => sendSong()}
              >
                {esEvento ? "Enviar evento" : "Enviar canción"}
              </LoadingButton>
            </FormControl>
          </Box>
        ) : (
          <Box sx={style}>
            <Stack>
              <Stack alignItems="center" spacing={2}>
                <Box width="150px" height="150px">
                  <img
                    src={info.profileimg || "/assets/AVATAR.jpg"}
                    width="100%"
                    style={{
                      objectFit: "cover",
                      borderRadius: "50%",
                      border: "2px solid #F27224",
                    }}
                  />
                </Box>
                {/* info */}
                <Stack>
                  <Stack
                    sx={{
                      "& > legend": { mt: 2 },
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <Rating
                      name="read-only"
                      value={info.rating_prom}
                      readOnly
                    />
                  </Stack>
                  <Typography variant="subtitle1" textAlign="center">
                    {info.nombre_media}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    textAlign="center"
                    fontWeight="400"
                    color="#F27224"
                    mt="-10px"
                  >
                    {info.tipo}
                  </Typography>
                  {info.acepta5RC && (
                    <Stack alignItems="center" mt={1}>
                      <Insignia5RC tipo={info.tipo} />
                    </Stack>
                  )}
                  <Typography variant="body1" color="grayText" fontWeight="400">
                    {info.descripcion}
                  </Typography>
                  {info.pagina_web && (
                    <Typography variant="subtitle1" fontWeight="400">
                      <strong>Visitame en </strong>
                      <a
                        href={hrefSeguro(info.pagina_web)}
                        target="_blank"
                        rel="nofollow noreferrer"
                        style={{
                          textDecoration: "underline",
                          color: "#F27224",
                        }}
                      >
                        Mi pagina web.
                      </a>
                    </Typography>
                  )}
                </Stack>
                {/* Redes sociales: solo se muestran las que el difusor registró */}
                <Stack direction="row" flexWrap="wrap" gap={1}>
                  {socialNetwork
                    .filter(({ name }) => info[name])
                    .map(({ name, Icon }, i) => (
                      <Button
                        key={i}
                        sx={{
                          py: 1,
                          px: 1,
                          minWidth: "auto",
                          ":hover": {
                            color: "#ffffff",
                            bgcolor: "#F27224",
                          },
                        }}
                        variant="outlined"
                        href={hrefSeguro(info[name])}
                        target="_blank"
                      >
                        <Icon />
                      </Button>
                    ))}
                </Stack>
              </Stack>
            </Stack>
          </Box>
        )}
      </Modal>
    </>
  );
}
